// @flow

import React, { Component } from "react";
import { Form, FormControl, FormGroup, Col, Button } from "react-bootstrap";

import "./Google.css";

type Props = {
  search: (q: string, index: ?number) => void
};

type State = {
  query: string
};

class SearchBox extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { query: "" };
  }

  render() {
    return (
      <div className="SearchBox">
        <Form
          horizontal
          action=""
          onSubmit={e => {
            this.props.search(this.state.query);
            e.preventDefault();
          }}
        >
          <FormGroup>
            <Col sm={8}>
              <FormControl
                autoFocus
                type="text"
                placeholder="Your Google Query"
                value={this.state.query}
                onChange={e => this.setState({ query: e.target.value })}
              />
            </Col>
            <Col sm={2} className="SearchBox-Button-Column">
              <Button type="submit">Search Google</Button>
            </Col>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

export default SearchBox;



// WEBPACK FOOTER //
// ./src/components/Google/SearchBox.js